module.exports = __webpack_public_path__ + "static/Baquet1-1d728e614501b05d765bad6404b68b91.jpg";